import Cookies from 'js-cookie';

export const bookInit = function () {
	const $element = $('[data-book]');

	if ($element.length) {
		window.document.addEventListener(
			'mouseout',
			function (event) {
				let y = 0;
				if (event.touches && event.touches.length) {
					y = event.touches[0].clientY || 0;
				} else {
					y = event.clientY || 0;
				}

				if (y <= 0 && $.magnificPopup && !$.magnificPopup.instance.isOpen && !Cookies.get('book')) {
					$element.trigger('click');
				}
			},
			{ passive: false }
		);
	}
};



// WEBPACK FOOTER //
// ./src/js/_modules/book.js